import { QueryHookOptions } from '@apollo/client';
import { useInfiniteQuery } from 'hooks/useInfiniteQuery';
import getManagedDepotsQuery from '../../hooks/managedDepotsFromPlatformAccount.graphql';

export const useManagedDepotsFromPlatformAccountQuery = (
  options: QueryHookOptions<ManagedDepotsQuery, ManagedDepotsQueryVariables>,
) => {
  return useInfiniteQuery<ManagedDepotsQuery, ManagedDepotsQueryVariables>(
    getManagedDepotsQuery,
    {
      fieldName: 'managedAssetGroupings',
      ...options,
    },
  );
};
